import { jsx as _jsx } from "react/jsx-runtime";
import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";
import { default as SignPost } from "../../../assets/404.svg";
import { LandingFeatureErrorPage } from "../../error-page/landing-feature-error-page";
var CustomError = function(param) {
    var statusCode = param.statusCode, error = param.error;
    useEffect(function() {
        if (process.env["STAGE_NAME"] !== "local") {
            datadogRum.addError(new Error("An error of statusCode ".concat(statusCode)), {
                route: window.location.pathname,
                errorInformation: error
            });
        } else {
            console.log({
                error: error,
                statusCode: statusCode
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ _jsx(LandingFeatureErrorPage, {
        title: "".concat(statusCode, " - Oops! Something went wrong"),
        subTitle: "Don’t worry, we can put you back on track!",
        image: SignPost,
        hasCta: true,
        ctaText: "Take me home",
        ctaHref: "/"
    });
};
CustomError.getInitialProps = function(param) {
    var res = param.res, req = param.req, err = param.err, query = param.query, pathname = param.pathname;
    var ref;
    var statusCode = res ? res.statusCode : err ? err.message : 404;
    var errorLogs = {
        url: req === null || req === void 0 ? void 0 : req.url,
        pathname: pathname,
        query: query,
        cookies: req === null || req === void 0 ? void 0 : (ref = req.headers) === null || ref === void 0 ? void 0 : ref.cookies,
        headers: req === null || req === void 0 ? void 0 : req.headers
    };
    var error = err ? err : errorLogs;
    return {
        statusCode: statusCode,
        error: error
    };
};
export default CustomError;
